import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const UserFormAdminVuexModule = {
  namespaced: true,
  state: () => ({
    $_moduleApiPath: "AccountUsers/v1.0/",
    $_errorState: {}
  }),
  getters: {
    errorState: (state) => state.$_errorState
  },
  actions: {
    clear({ commit }) {
      commit("SET_ERROR", {});
    },
    async ChangePasswordAdminHandler(
      { commit, dispatch, state, rootGetters },
      data
    ) {
      var authUrl = rootGetters.authUrl;
      var actionLink = `${authUrl}${state.$_moduleApiPath}ChangePasswordAdminAsync`;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        let response = await axios.post(actionLink, data.data, axiosConfig);
        var salida = response.data;
        if (salida.success) {
          return true;
        } else {
          commit("SET_ERROR", salida.message);
          throw salida.message;
        }
      } catch (error) {
        GetErrors(commit, error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async ResetPasswordAdminHandler(
      { commit, dispatch, state, rootGetters },
      data
    ) {
      var authUrl = rootGetters.authUrl;
      var actionLink = `${authUrl}${state.$_moduleApiPath}ResetPasswordAsync`;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        var payload = { id: data.data.UserId };
        const response = await axios.put(actionLink, payload, axiosConfig);
        var salida = response.data;
        if (salida.success) {
          return true;
        } else {
          commit("SET_ERROR", salida.message);
          throw salida.message;
        }
      } catch (error) {
        GetErrors(commit, error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    },
    async demo(data) {
      console.log("data", data);
    },
    async UnlockUserAdminHandler(
      { commit, dispatch, state, rootGetters },
      data
    ) {
      var authUrl = rootGetters.authUrl;
      var actionLink = `${authUrl}${state.$_moduleApiPath}UnlockAccountAsync`;
      var axiosConfig = rootGetters.axiosConfig;
      try {
        var payload = { id: data.data.UserId };
        const response = await axios.put(actionLink, payload, axiosConfig);
        var salida = response.data;
        if (salida.success) {
          return true;
        } else {
          commit("SET_ERROR", salida.message);
          throw salida.message;
        }
      } catch (error) {
        GetErrors(commit, error);
        await dispatch("handleUnauthorizedError", error, {
          root: true
        });
      }
    }
  },
  mutations: {
    SET_ERROR(state, value) {
      state.$_errorState = value;
    }
  }
};

function GetErrors(commit, error) {
  var dataError = JSON.parse(JSON.stringify(error.response.data));
  var dataMessage = JSON.parse(JSON.stringify(dataError.errors[0]));
  commit("SET_ERROR", dataMessage);
}

export default UserFormAdminVuexModule;
